// extracted by mini-css-extract-plugin
module.exports = {"socialList":"c_f","socialListItem":"c_g","socialLink":"c_h"};